export default "__VITE_ASSET__e888e491__"